"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dateFns = require("date-fns");

exports.isDateOlderThanSeconds = function (date, seconds) {
  return dateFns.isBefore(dateFns.addSeconds(date, seconds), new Date());
};

exports.default = exports.isDateOlderThanSeconds;